import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { Actions } from '../../actions';
import { GetTracLinkDsps, GetTracLinkDspsSuccess } from '../action-creators';
import { GET_TRAC_LINK_DSPS } from '../actions';
import AppState from '../../state';
import TracLink from '@services/tracpage/types/trac-link';

import { NoOp } from '@webapp/store/ui/action-creators';
import { TracLinkPlatform } from '@services/tracpage/types/trac-link-platform';
import { TracPageLink } from '@services/tracpage/types/trac-page-link';

const AVAILABLE_SERVICES: TracLinkPlatform[] = [
  'custom',
  'spotify',
  'appleMusic',
  'tidal',
  'amazonMusic',
  'youtube',
  'deezer',
  'pandora',
  'napster',
];

export const getTracLinkDspsEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, GetTracLinkDsps>(GET_TRAC_LINK_DSPS),
    withLatestFrom(state$),
    mergeMap(async ([{ links, tracpageId }, _]) => {
      try {
        const filteredLinks = links.filter((l) => l.type === 'traclink');
        const traclinks = filteredLinks
          .map((l) => l.url?.replace('/', '') ?? '')
          .filter(Boolean);

        const traclinkData: TracLink[] = await Promise.all(
          traclinks.map((tl) =>
            fetch(
              `${process.env.REACT_APP_PRODUCT_BASE_URL}/trac-link/${tracpageId}/${tl}/data.json`
            )
              .then((response) => {
                if (response.ok) {
                  return response.json();
                }
                return {} as TracLink;
              })
              .catch(() => {
                return {} as TracLink;
              })
          )
        );

        const storesDataEntries = traclinkData.map((data) => {
          const stores = getStores(data);
          return [data.path, stores];
        });

        const storesMap: Record<string, TracPageLink[]> =
          Object.fromEntries(storesDataEntries);

        return new GetTracLinkDspsSuccess(storesMap);
      } catch (err) {
        return new NoOp();
      }
    })
  );

export const getStores = (data: TracLink): TracPageLink[] => {
  if (!data.links) {
    return [];
  }

  return data.links
    .map((item) => {
      if (item.platform && item.platform.length > 0) {
        return item;
      }
      const platform = getTitlePlatform(item.title, AVAILABLE_SERVICES);
      return {
        ...item,
        platform: platform,
      };
    })
    .filter((item) => AVAILABLE_SERVICES.some((as) => as === item.platform))
    .filter((track) => track.url && track.url.length > 0);
};

const getTitlePlatform = (text: string, platforms: TracLinkPlatform[]) =>
  platforms.find((plat) => text.toLowerCase().includes(plat));
